import { Object3D } from "three";
import Loader from "../Loader";
import { IWeapon } from "./IWeapon";

class Sword implements IWeapon {
    public model: Object3D | null = null;

    constructor(loader: Loader) {
        loader.loadModel(
            `${process.env.ASSET_URL}/models/sword.dae`,
            (model: Object3D) => {
                this.model = model;

                this.model.name = "sword";
                this.model.position.set(0.2, -0.2, -0.4);
                const size = 0.2;
                this.model.scale.set(size, size, size);
                this.model.rotation.set(-Math.PI * 0.1, Math.PI / 2, 0);
            }
        );
    }
}

export default Sword;
